// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iLCI","newExpiryDate":"styles_newExpiryDate__V7Et_","footer":"styles_footer__2RP-B"};